import script from "./ShareButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareButton.vue?vue&type=script&setup=true&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=3c4acf58&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4acf58"]])

export default __exports__